import { useState } from "react";
import { X } from "lucide-react";

/**
 * Floating BETA sticker — signals visitors that Call Sheet is still under
 * active development. Rendered globally from App.js so it persists on every
 * route (including auth/onboard screens where the AppHeader is hidden).
 */
export default function BetaBadge() {
  const [dismissed, setDismissed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className="fixed bottom-4 left-4 z-[60] select-none"
      data-testid="beta-badge"
    >
      <div
        className="group relative flex items-center gap-2 rounded-full border border-[#F5B82E]/40 bg-black/70 pl-3 pr-2 py-1.5 backdrop-blur-md shadow-[0_0_24px_rgba(245,184,46,0.15)] transition hover:border-[#F5B82E]/70 hover:shadow-[0_0_32px_rgba(245,184,46,0.35)] cursor-pointer"
        onClick={() => setExpanded((v) => !v)}
        data-testid="beta-badge-pill"
      >
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F5B82E] opacity-60" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#F5B82E]" />
        </span>
        <span className="font-display text-[10px] tracking-[0.28em] uppercase text-[#F5B82E]">
          Beta
        </span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setDismissed(true);
          }}
          className="ml-1 rounded-full p-0.5 text-white/50 hover:text-white hover:bg-white/10 transition"
          aria-label="Dismiss beta notice"
          data-testid="beta-badge-dismiss"
        >
          <X size={12} />
        </button>
      </div>

      {expanded && (
        <div
          className="mt-2 max-w-[280px] rounded-lg border border-white/10 bg-black/85 p-3 backdrop-blur-md shadow-2xl"
          data-testid="beta-badge-tooltip"
        >
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#F5B82E] mb-1">
            Preview Build
          </div>
          <p className="text-xs leading-relaxed text-white/70">
            Call Sheet is in active development. Some flows are still being
            refined — thanks for previewing early. Feedback welcome.
          </p>
        </div>
      )}
    </div>
  );
}
